import {Image} from 'ol/layer.js';
import Static from 'ol/source/ImageStatic.js';
import Projection from 'ol/proj/Projection.js';
import {Layer} from './Layer.js';

export class ImageLayer extends Layer {
    api_path = "";
    api_endpt = "";

    constructor( map, settings = {}){
        if( settings['name'] == undefined ) settings["name"] = 'image';
        if( settings['opacity'] == undefined ) settings["opacity"] = 1;
        super( map, settings );
        this.api_path = this.map.server + "/cgi-bin/image";
        this.api_endpt = settings["api_endpt"];
        this.getState();

        let url = this.getUrl();
        let extent = this.getExtent();

        this.source = new Static({
                "url": url,
                "imageExtent": extent,
                "projection": new Projection({"code": "EPSG:3857"})
                });
        this.layer = new Image({
                "source": this.source,
                "opacity": this.settings['opacity'],
                "visible": this.settings['visible'] });

    }

    getUrl( ){
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "model", "rap" );
        url.searchParams.set( "level", "sfc" );
        url.searchParams.set( "type", "temp" );
        console.info( 'II', url.toString() );
        return url.toString();
    }

    getExtent( model ){
        return [ -14990770, 2139913, -6827850, 8032833 ];
    }

    refresh(){
        this.layer.getSource().refresh();
    }

    set( key, val ){
        if( key in this.settings ){
            super.set( key, val );
            return 1;
        }
        return 0;
    }

    updateSource(){
        let url = this.getUrl();
        let extent = this.getExtent();
        this.source = new Static({
            "url": url,
            "imageExtent": extent,
            "projection": new Projection({"code": "EPSG:3857"})
            });
        this.layer.setSource( this.source );
    }
}
